import { styled, LinearProgress, Box, Typography } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}));

export const StyledHeaderAndLabelWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const StyledHeader = styled(Typography)({
  fontSize: '18px',
  fontWeight: 500,
});

export const StyledLimitsContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const StyledLimitsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: 'fit-content',
  gap: theme.spacing(0.5),
}));
export const StyledUsedTypography = styled(Typography)({
  color: '#6D77C8',
  fontSize: '18px',
  fontWeight: 700,
});

export const StyledTotalTypography = styled(Typography)({
  color: '#4B5563',
  fontSize: '18px',
  fontWeight: 700,
});

export const StyledTypography = styled(Typography)({
  color: '#4B5563',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
});

export const StyledLinearProgress = styled(LinearProgress)({
  height: '40px',
  borderRadius: '20px',
  backgroundColor: '#E5E7EB',
  '& .MuiLinearProgress-bar': {
    borderRadius: '20px',
    background: '#6D77C8',
  },
});
